module.exports = __webpack_public_path__ + "img/ppt-addin-03.52d0daab.png";